import { Theme, css } from '@emotion/react';

export const internalWrapper = ({ spacing, borderRadius, colors }: Theme) => {
  return css`
    border-radius: ${borderRadius[100]};
    border: 1px solid ${colors.borderInternalBase};
    padding: ${spacing(3)}px;
    position: relative;
    box-shadow: 0 0 0 4px var(--sunglow-lighter);
  `;
};

export const internalIdentifier = ({ spacing, borderRadius, colors }: Theme) => {
  return css`
    position: absolute;
    top: 0;
    left: ${spacing(1)}px;
    transform: translateY(-50%);
    background: ${colors.borderInternalBase};
    color: ${colors.fgContrast};
    padding: ${spacing(0.25)}px ${spacing(1)}px;
    border-radius: ${borderRadius[100]};
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${spacing(0.5)}px;
  `;
};

// This override is because of the misalignment due to the font size being set to a decimal of 15.95px. [Remove this once the Typography component has been updated]
export const internalIdText = ({ spacing, shape, colors }: Theme) => {
  return css`
    line-height: 1;
  `;
};
